import React, { useContext } from "react";
import { Outlet } from "react-router-dom";

import { EducationContext } from "shared/context/EducationContext";

import DashboardWrapper from "../features/dashboard/components/DashboardWrapper";
import Footer from "./components/Footer";

const EducationLayout = () => {
  const { state } = useContext(EducationContext);

  return (
    <DashboardWrapper breadcrumb={null} state={state}>
      <Outlet />

      <Footer />
    </DashboardWrapper>
  );
};

export default EducationLayout;
